var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2-filled-16x16",
    clipPath: "url(#clip0_5087_39641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.60938 14.3906H12.4195",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.22842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.50579 10.9511L4.55759 11.4817L5.04895 8.49422L11.6628 1.90007C11.7541 1.80796 11.8628 1.73485 11.9826 1.68495C12.1023 1.63506 12.2308 1.60938 12.3605 1.60938C12.4902 1.60937 12.6187 1.63506 12.7384 1.68495C12.8582 1.73485 12.9669 1.80796 13.0582 1.90007L14.0999 2.94177C14.1921 3.03312 14.2652 3.14181 14.3151 3.26157C14.3649 3.38133 14.3906 3.50977 14.3906 3.63951C14.3906 3.76924 14.3649 3.89769 14.3151 4.01744C14.2652 4.1372 14.1921 4.24589 14.0999 4.33725L7.50579 10.9511Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.22842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5087_39641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFilled);
export default __webpack_public_path__ + "static/media/editFilled.f57bfe1726804c4e268d066895edb785.svg";
export { ForwardRef as ReactComponent };